import { axiosPost, axiosGet, axiosPatch } from './axiosFunctions';
import { getTokenOrLogout } from './common';

const getDocumentTypesUrl    = '/api/clientDocument/getDocumentTypes';
const getByGroupUrl          = (groupId) => `/api/clientDocument/getByGroup/${groupId}`;
const getAllUrl              = '/api/clientDocument/getAll';
const addDocumentUrl         = '/api/clientDocument/add';
const updateDocumentUrl      = '/api/clientDocument/update';
const deactivateDocumentUrl  = (id) => `/api/clientDocument/deactivate/${id}`;

export const getClientDocumentTypes = async () => {
    const token = getTokenOrLogout();
    if (!token) setTimeout(()=> { return }, 2000);

    const response = await axiosGet(getDocumentTypesUrl, {
        headers: { auth_token: `bearer ${token}` },
    });
    return response;
};

export const getClientDocumentsByGroup = async (groupId) => {
    const token = getTokenOrLogout();
    if (!token) setTimeout(()=> { return }, 2000);

    const response = await axiosGet(getByGroupUrl(groupId), {
        headers: { auth_token: `bearer ${token}` },
    });
    return response;
};

export const getAllClientDocuments = async () => {
    const token = getTokenOrLogout();
    if (!token) setTimeout(()=> { return }, 2000);

    const response = await axiosGet(getAllUrl, {
        headers: { auth_token: `bearer ${token}` },
    });
    return response;
};

export const addClientDocument = async (document) => {
    const token = getTokenOrLogout();
    if (!token) setTimeout(()=> { return }, 2000);

    const response = await axiosPost(
        addDocumentUrl,
        { document },
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const updateClientDocument = async (document) => {
    const token = getTokenOrLogout();
    if (!token) setTimeout(()=> { return }, 2000);

    const response = await axiosPost(
        updateDocumentUrl,
        { document },
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};

export const deactivateClientDocument = async (id) => {
    const token = getTokenOrLogout();
    if (!token) setTimeout(()=> { return }, 2000);

    const response = await axiosPatch(
        deactivateDocumentUrl(id),
        null,
        { headers: { auth_token: `bearer ${token}` } }
    );
    return response;
};
